/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * WebQuestionAnswersTypeBase
 * auto generated base class for the model WebQuestionAnswersTypeModel.
 */
export const WebQuestionAnswersTypeModelBase = ModelBase.named('WebQuestionAnswersType')
  .props({
    __typename: types.optional(types.literal('WebQuestionAnswersType'), 'WebQuestionAnswersType'),
    answer: types.union(types.undefined, types.string),
    question: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WebQuestionAnswersTypeModelSelector extends QueryBuilder {
  get answer() {
    return this.__attr('answer')
  }
  get question() {
    return this.__attr('question')
  }
}
export function selectFromWebQuestionAnswersType() {
  return new WebQuestionAnswersTypeModelSelector()
}

export const webQuestionAnswersTypeModelPrimitives = selectFromWebQuestionAnswersType().answer.question
